<template>
  <div name="reports">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Reporting</h2>

        <img v-if="currentUser.isSecondaryBased"
          @click="openInNewTab('https://www.pescholar.com/insight/the-primary-physical-education-concept-curriculum/')"
          class="pl-2 w-2/12 object-scale-down"
            src="/static/images/pescholar-collab.png"
            alt=""
          /> 


        <UpgradeOption v-if="shouldShowUpgrade" @pressed="showUpgrade()">
        </UpgradeOption>
      </div>
    </header>

    <div class="header-subnav-holder">

      <button
        v-for="path in tabsList"
        :key="path.id"
        type="button"
        class="header-subnav focus:outline-none"
        @click="showPath(path)"
        v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
      >
        {{ path.name }}
      </button>
    </div>


    <FilterBar :nosearch=true >
      <template v-slot:filter>
        <div>

            <dropdown :options="calendarDropdown" :selected="filterValue.calendar" v-on:updateOption="updateCalendarYear"
             class="w-72 bg-action-blue text-center bg-opacity-75 text-white"
             style="min-width: 20em;">
          ></dropdown>

  
                </div>
        <div>
          <button 
            type="button"
            class="filter-bar-button focus:outline-none hover:opacity-75"
            v-bind:class="filterHasValues ? 'filter-item-button-on' : 'bg-white'"
            @click="showFilter()"
          >
            <i class="fas fa-filter"></i> Filters
          </button>
        </div>
        <div v-if="canShowExport">
        <button
          type="button"
          class="  filter-bar-button hover:opacity-75   focus:outline-none"
          @click="generateExport()"
        >
          <i class="fas fa-share-alt"></i>
          Export
        </button>
      </div>
        
      </template>

      <template v-slot:actions> </template>
    </FilterBar>


    <ReportingFilterModal
      class=""
      v-if="filterIsVisible"
      :calendar="filterValue.calendar"
      :values="filterValue"
      :filterPath="selectedPath.path"
      @apply-filter="applyFilter"
      @close="showFilter"
    >
    </ReportingFilterModal>


  
    <router-view ref="reportview" :filterValues="filterValue" :hasAccess="hasAccess" v-if="filterValue != undefined" class="pb-24"  />

        <UpgradeModal
      v-if="showUpgradeModal"
      @close="showUpgrade()"
      :area="'Reporting'"
    ></UpgradeModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ReportingFilter } from "@/services/reporting.service"
import { filterTypeList, calendarYearList } from "@/assets/js/utils";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const UpgradeModal = () => import("@/components/upgrade/UpgradeModal.vue");
const UpgradeOption = () => import("@/components/upgrade/UpgradeOption.vue");

const dropdown = () => import("@/components/Dropdown.vue");

const FilterBar = () => import("@/components/FilterBarNavigation.vue");
const ReportingFilterModal = () => import("@/components/helpers/ReportingFilter.vue");

export default {
  name: "reports",
    mixins: [upgradeMixin],
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
         hasAccess() {
       if (this.currentUser.isOnFree) {
            return this.currentAccess.reportingAccess
       } else {
        return true
       }
    },
    canShowExport() {
      return this.hasAccess && [4,5].includes(this.selectedPath.id)
    },
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
 tabsList() {
      return this.tabs
    },
    calendarDropdown() {
      var results = calendarYearList().slice(0, 3);;
      this.selectedCalendar = results[0];
      return results;
    },
    filterHasValues() {
      var value = this.filterValue
      if (value.group != undefined || value.years != undefined || value.types != undefined || (value.tags != undefined && value.length > 2)) {
        return true
      }
    },
    filteredYears() {
      return this.filterValue.years != undefined ?  this.filterValue.years : []
    },
    filteredTypes() {
      return this.filterValue.types != undefined ?  this.filterValue.types : []
    },
    filteredClass(){
      return this.filterValue.group != undefined ? this.filterValue.group : {}
    },
  },
  data() {
    return {
      loading: false,
      tabs: [],
      selectedPath: {},
      types: filterTypeList(),

      filterValue: undefined,
      filterIsVisible: false,
      workingAtVisible: false,
      filterButtonVisible: true
    };
  },
  created() {
    this.loading = true;
    this.resetFilter()
  },
  mounted() {
     this.tabs = [
      {id: 1, name: "Overview", path: "report-overview"},
      {id: 2, name: "Breakdown", path: "report-breakdown"},
      {id: 3, name: "Assessment Grade", path: "report-assessments"},
      {id: 4, name: "Extra Curricular", path: "report-extracurricular"},
      {id: 5, name: "Events", path: "report-events"},
      {id: 6, name: "Pupil Timeline", path: "report-timeline"},
      {id: 7, name: "Evidence Archive", path: "evidences"},
    ]

    this.selectedPath = this.tabs[0]
  },
  methods: {
    resetFilter() {
        let calendarYear = calendarYearList().find((y) => y.current === true);
        this.filterValue = new ReportingFilter(calendarYear);
        this.filterValue.tags = "";
      },
    showPath(object) { 
      if (this.selectedPath.id === object.id) { return }
      this.selectedPath = object;
      this.$router.push("/reports/" + object.path);
    },
    updateCalendarYear(cal) {
      this.filterValue.calendar = cal;
    },
    applyFilter(filters) {
      this.filterValue = filters;

      this.showFilter();
    },
    showFilter() {
      this.filterIsVisible = !this.filterIsVisible;
    },
    generateExport() {
      console.log("PRINT")
      this.$refs.reportview.generatePrint(this.selectedPath)
  }
  },
  components: {
    FilterBar,
    ReportingFilterModal,
    dropdown,
        UpgradeModal,
    UpgradeOption,
  },
};
</script>

<style scoped>
</style>